export interface IPropertyResponseMapInfo
{
    key:PropertyResponse;
    value:PropertyResponse;
}

export interface IPropertyResponseEnumValue
{
    key:string;
    label:string;
}

export interface IPropertyResponseEnumLabel
{
    key:string;
    label:string;
}

export class PropertyResponse
{
    public readonly name:string;
    public readonly description:string;
    public readonly defaultValue:any;
    public readonly nullable:any;
    public readonly typeDescriptor:string;
    public readonly label:string;
    public readonly widget:string;
    public readonly placeholder:string;
    public readonly category:string;
    public readonly index:number;
    public readonly enumValues:IPropertyResponseEnumValue[];
    public readonly enumLabels:IPropertyResponseEnumLabel[];
    public readonly validation:any;
    public readonly visibility:any;
    public readonly mapInfo:IPropertyResponseMapInfo;
    public readonly listItem:PropertyResponse;

    constructor(json:any)
    {
        this.name = json['name'];
        this.description = json['description'];
        this.defaultValue = json['defaultValue'];
        this.nullable = json['nullable'];
        this.typeDescriptor = json['typeDescription'];
        this.label = json['label'];
        this.widget = json['widget'];
        this.placeholder = json['placeholder'];
        this.category = json['category'];
        this.index = json['index'];
        this.enumValues = json['enumValues'];
        this.enumLabels = json['enumLabels'];
        this.validation = json['validation'];
        this.visibility = json['visibility'];
        this.mapInfo = json['mapInfo'];
        this.listItem = json['listItem'];
    }
}
